import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";

export default function AboutPage() {
  return (
    <Layout>
      {/* Hero */}
      <header className="hero">
        <div className="container hero-grid">
          <div>
            <div className="hero-kicker">AUTHOR &amp; CREATOR OF TRANSFORMATION SYSTEMS</div>
            <h1 className="hero-title">
              MEET RAJESH SIVACHARYA <br />
              <span className="text-gold">AUTHOR • CREATOR • TRANSFORMATION GUIDE</span>
            </h1>
            <blockquote style={{ fontFamily: "var(--font-serif)", fontSize: "1.4rem", color: "var(--gold-warm)", margin: "20px 0", borderLeft: "3px solid var(--gold-warm)", paddingLeft: "20px", fontStyle: "italic" }}>
              "What if the life you're living is not the only life you're capable of creating?"
            </blockquote>
            <p className="hero-subtitle">
              I write about the patterns, beliefs, identities, and choices that shape the life we create—and the practical systems that can help us change them.
            </p>
          </div>

          <div style={{ textAlign: "center" }}>
            <div style={{ background: "var(--navy-card)", border: "1px solid var(--border-gold)", borderRadius: "var(--radius-xl)", padding: "48px", textAlign: "center" }}>
              <div style={{ width: "120px", height: "120px", borderRadius: "50%", border: "2px solid var(--gold-warm)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--font-serif)", fontSize: "3rem", color: "var(--gold-warm)", margin: "0 auto 20px auto" }}>
                RS
              </div>
              <h3 className="font-serif" style={{ fontSize: "2.2rem", color: "var(--gold-warm)" }}>Rajesh Sivacharya</h3>
              <p style={{ color: "var(--text-muted)", fontSize: "0.95rem", marginTop: "4px" }}>Author &amp; Creator of Transformation Systems</p>
            </div>
          </div>
        </div>
      </header>

      {/* Philosophy */}
      <section className="container section-padding" style={{ borderTop: "1px solid var(--border-glass)" }}>
        <div style={{ maxWidth: "840px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "2.6rem", marginBottom: "24px" }}>THE PHILOSOPHY BEHIND THE WORK</h2>
          <p style={{ fontSize: "1.1rem", color: "var(--text-secondary)", lineHeight: 1.8, marginBottom: "24px" }}>
            Through The Identity Shift™, Rajesh Sivacharya explores the intersection of neuroscience, identity, mindset, inherited patterns, conscious creation, and daily practice.
          </p>
          <p style={{ fontSize: "1.05rem", color: "var(--text-secondary)", lineHeight: 1.8, marginBottom: "24px" }}>
            His work is designed to move beyond inspiration:
          </p>
          <div style={{ background: "var(--navy-card)", border: "1px solid var(--border-gold)", borderRadius: "var(--radius-lg)", padding: "32px", marginBottom: "40px" }}>
            <ul style={{ listStyle: "none", fontSize: "1.1rem", lineHeight: 2, color: "var(--gold-warm)", fontWeight: 600 }}>
              <li>✓ Understand the pattern.</li>
              <li>✓ Question the identity.</li>
              <li>✓ Practice the shift.</li>
              <li>✓ Create what comes next.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Two Product Worlds */}
      <section className="container section-padding" style={{ borderTop: "1px solid var(--border-glass)" }}>
        <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto 48px auto" }}>
          <div className="hero-kicker">INTELLECTUAL PROPERTY HUBS</div>
          <h2 style={{ fontSize: "2.8rem" }}>THE WORK</h2>
        </div>

        <div className="grid-2">
          <div className="world-card">
            <div>
              <div className="world-tag">THE IDENTITY SHIFT™</div>
              <h3 className="world-title font-serif" style={{ color: "var(--gold-warm)" }}>Personal Transformation</h3>
              <p className="world-desc">
                A transformation ecosystem built around books, 30-day journals, and daily practice tools designed to help readers understand their patterns, rewire subconscious conditioning, and build a new identity.
              </p>
            </div>
            <div style={{ marginTop: "24px" }}>
              <Link to="/identity-shift" className="btn btn-primary-gold">EXPLORE THE IDENTITY SHIFT™ →</Link>
            </div>
          </div>

          <div className="world-card">
            <div>
              <div className="world-tag">CAREER &amp; WEALTH</div>
              <h3 className="world-title font-serif" style={{ color: "var(--gold-warm)" }}>Financial Transformation</h3>
              <p className="world-desc">
                A practical pathway for young professionals learning to turn their first decade of income into a foundation for long-term financial freedom, anchored by <em>Rich by Thirty, Broke by Thirty</em>.
              </p>
            </div>
            <div style={{ marginTop: "24px" }}>
              <Link to="/career-wealth" className="btn btn-outline">EXPLORE CAREER &amp; WEALTH →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="container section-padding" style={{ textAlign: "center", maxWidth: "800px" }}>
        <h2 style={{ fontSize: "2.8rem", marginBottom: "16px" }}>
          YOU ARE NOT DEFINED BY YOUR PAST. <br />
          <span className="text-gold">YOU ARE DESIGNED BY YOUR CHOICES.</span>
        </h2>
        <p style={{ fontSize: "1.2rem", fontFamily: "var(--font-serif)", color: "var(--gold-warm)", marginBottom: "32px" }}>
          REWIRE. RISE. BECOME.
        </p>
        <Link to="/checkout" className="btn btn-primary-gold btn-lg">EXPLORE THE COLLECTION →</Link>
      </section>
    </Layout>
  );
}
